import $ from "jquery";
import "jquery-validation";
import Swal from 'sweetalert2';
import { showCaptchaDialog } from "framework/index";
import { Password } from "@bidiao/framework"
const $frmMain = $(document.forms["frmMain"]);
function lockFormLogin() {
    $("fieldset", $frmMain).prop("disabled", true);
}
function unlockFormLogin() {
    $("fieldset", $frmMain).prop("disabled", false);
}

$.validator.addMethod("userNameFormat", function (value, element, parms) {
    if (!value) return true;
    return /^1[3-9]\d{9}$/.test(value) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}, "手机号/邮箱格式错误");
$frmMain.validate({
    errorClass: "is-invalid",
    errorElement: "span",
    ignore: ":hidden,.ignore",// 增加忽略检测的元素
    validClass: "is-valid",
    errorPlacement(error, inputElement) {
        error.addClass("invalid-message");
        error.insertAfter(inputElement);
    },
    rules: {
        "Input.Username": {
            required: true,
            remote: "?handler=CheckUser",
            userNameFormat: true,
        },
        "Input.Password": {
            required: true,
            minlength: 6
        },
        "Input.ConfirmPassword": {
            required: true,
            equalTo: $("[name='Input.Password']", $frmMain)
        }
    },
    messages: {
        "Input.Username": {
            required: "请输入手机号/邮箱",
            remote: "注册账号已被使用"
        },
        "Input.Password": {
            required: "请输入密码",
            minlength: "密码长度不能小于6位"
        },
        "Input.ConfirmPassword": {
            required: "请再次输入密码",
            equalTo: "两次密码输入的不一致"
        }
    }
});

const levelColors = ["!text-red-500", "!text-yellow-500", "!text-green-500", "!text-green-500"];
// 密码强度条控制
$("[name='Input.Password']", $frmMain).on("input", evt => {
    const val = $("[name='Input.Password']", $frmMain).val() as string;
    if (!val || val.length === 0) {
        $(".password-strong-bar", $frmMain).css({
            "--fill-weight": `0%`,
        });
        return;
    }

    const level = Password.checkPassword(val);// 校验密码强度

    $(".password-strong-bar", $frmMain).css({
        "--fill-weight": `${level / 6 * 100}%`,
    }).removeClass(levelColors)
        .addClass(levelColors[Math.floor((level - 1) / 2)])
})

$(document).on("submit", $frmMain, async evt => {
    evt.preventDefault();
    lockFormLogin();
    if (!$("[name='Input.Agree']", $frmMain).is(":checked")) {
        const dialogResult = await Swal.fire({
            scrollbarPadding: false,
            html: `<span class="align-middle">我已阅读并同意</span>
<a class="align-middle text-blue-600 hover:text-blue-700" href="#">服务协议</a>
<span class="align-middle">和</span>
<a class="align-middle text-blue-600 hover:text-blue-700" href="#">隐私政策</a>`,
            icon: "info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "同意",
            cancelButtonText: "不同意"
        });
        // 判断是否操作的取消
        if (dialogResult.dismiss) {
            unlockFormLogin();
            return;
        }
        // 选择同意后，设置选中状态
        $("[name='Input.Agree']", $frmMain).prop("checked", true);
    }

    try {
        // 判断登录模式是否密码登录
        const captchaToken = await showCaptchaDialog("Register");

        $("[name='Input.CaptchaToken']", $frmMain).val(captchaToken);

        const redirectUrl = await $.ajax("?handler=RegisterAjax", {
            type: "POST",
            data: {
                "Input.Username": $("[name='Input.Username']", $frmMain).val(),
                "Input.Password": $("[name='Input.Password']", $frmMain).val(),
                "Input.ConfirmPassword": $("[name='Input.ConfirmPassword']", $frmMain).val(),
                "Input.CaptchaToken": $("[name='Input.CaptchaToken']", $frmMain).val(),
                "Input.Agree": $("[name='Input.Agree']", $frmMain).val(),
                "__RequestVerificationToken": $("[name='__RequestVerificationToken']").val(),
            },
            statusCode: {
                400: function (res) {
                    Swal.fire({
                        scrollbarPadding: false,
                        text: res.responseText,
                        icon: "warning",
                        confirmButtonText: "好的👌"
                    });
                    unlockFormLogin();
                }
            }
        });
        debugger;
        location.replace(redirectUrl);
    } catch {

    } finally {
        unlockFormLogin();
    }
});